import styled from "styled-components";

export const OrderContent = styled.div`
  /* & .ant-table-row{
    cursor: pointer;
    width: 100%;
    height: 100%;
  } */

  /* 让表格容器占据剩余空间 */
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /* 表格内容区域的最大高度 = 视口高度 - 顶部导航栏 - Tab行 - 筛选行 - 分页器 - 边距 */
  & .ant-table-body {
    max-height: calc(100vh - 240px) !important;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 2px !important;
  }
`;
